export default from "./Horpyrion";



// WEBPACK FOOTER //
// ./src/index.js